
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/integrations/icon-libraries",
      function () {
        return require("private-next-pages/joy-ui/integrations/icon-libraries.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/integrations/icon-libraries"])
      });
    }
  